import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import {
  CreateSubscriptionModal,
  EditSubscriptionModal,
  SubscriptionListFilters,
} from "@modules/subscriptions/components";

import { useSubscriptionList } from "./controller";
import { useSubscriptionListColumns } from "./columns";

export const SubscriptionList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    createSubscriptionModalRef,
    editSubscriptionModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } = useSubscriptionList();

  const columns = useSubscriptionListColumns(
    refetch,
    translate,
    editSubscriptionModalRef
  );

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <SubscriptionListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="subscriptions.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createSubscriptionModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateSubscriptionModal
        onComplete={() => {
          refetch();
          setSelectedRows([]);
        }}
        modalRef={createSubscriptionModalRef}
      />
      <EditSubscriptionModal
        onComplete={() => {
          refetch();
          setSelectedRows([]);
        }}
        modalRef={editSubscriptionModalRef}
      />
    </List>
  );
});
